"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgbColorTraceName = exports.motorPosDifferentiation = void 0;
const motorPosDifferentiation = traceName => {
  const traceNameArr = traceName.split("=>");
  return traceNameArr[0] === "Motor Position" ? "Postion " + traceName.split("=>")[1] : traceName.split("=>")[1];
};
exports.motorPosDifferentiation = motorPosDifferentiation;
const rgbColorTraceName = traceName => {
  if (traceName === "Red Channel" || traceName === "Blue Channel" || traceName === "Green Channel") return traceName.toLocaleLowerCase().split(" ")[0];
  return "";
};
exports.rgbColorTraceName = rgbColorTraceName;